import { __rest } from "tslib";
import React from 'react';
export const NonDismissibleAlert = (_a) => {
    var { icon, children } = _a, otherProps = __rest(_a, ["icon", "children"]);
    return (React.createElement("div", Object.assign({}, otherProps),
        React.createElement("div", { className: 'kal-alert__icon', "aria-hidden": true }, icon),
        React.createElement("div", { className: 'kal-alert__content' }, children)));
};
//# sourceMappingURL=NonDismissibleAlert.js.map